import * as Yup from 'yup';

const emailSchema = Yup.string().email().required();
const countrySchema = Yup.string().required();
const firstNameSchema = Yup.string().required();
const lastNameSchema = Yup.string().required();

/**
 * This function validates a form with the following fields: email, country, firstName, lastName.
 * It also checks if the user has accepted the terms and the newsletter.
 *
 * @param {Object} form - The form data to validate. It should contain the following properties:
 * @param {string} form.email - The user's email.
 * @param {string} form.country - The user's country.
 * @param {string} form.firstName - The user's first name.
 * @param {string} form.lastName - The user's last name.
 * @param {boolean} form.newsletter - Whether the user has accepted the newsletter.
 * @param {boolean} acceptTerms - Whether the user has accepted the terms.
 *
 * @returns {{ isValid: boolean, message: string }} - The validation result.
 *
 */
export const validateForm = async (form, acceptTerms) => {
  const {
    email, country, firstName, lastName, newsletter,
  } = form;
  if (!(await emailSchema.isValid(email))) {
    return { isValid: false, message: 'Please enter a valid email address' };
  }
  if (!(await firstNameSchema.isValid(firstName)) || !(await lastNameSchema.isValid(lastName))) {
    return { isValid: false, message: 'Please enter your first and last name' };
  }
  if (!(await countrySchema.isValid(country))) {
    return { isValid: false, message: 'Please select your country' };
  }
  if (!acceptTerms || !newsletter) {
    return { isValid: false, message: 'Please agree to the terms to continue' };
  }
  return { isValid: true };
};
